const INITIAL_STATE = {
  enviar: {},
  isFetching: false,
};

export const enviarArquivoRequest = "ENVIAR_ARQUIVO_REQUEST";
export const enviarArquivoSuccess = "ENVIAR_ARQUIVO_SUCCESS";
export const enviarArquivoFailure = "ENVIAR_ARQUIVO_FAILURE";

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case enviarArquivoRequest:
      return { ...state, isFetching: true };
    case enviarArquivoSuccess:
      return {
        ...state,
        enviar: { ...action.payload },
        isFetching: false,
      };
    case enviarArquivoFailure:
      return {
        ...state,
        isFetching: false,
      };
    default:
      return state;
  }
};
